import { API_BASE } from '../../constants';
import { BenchmarkQuotesUseCase } from '../../usecases';
import { makeHttpGet } from '../http-get';
import {
  IBenchmarkQuotes,
  IGetAssetMemory,
  IGetBenchmarkColor,
  ISetAssetMemory
} from '../../interfaces';

export const makeComparisonBenchmarkQuotes = (
  getColorRepo: IGetBenchmarkColor,
  getInMemoryRepo: IGetAssetMemory<IBenchmarkQuotes> & ISetAssetMemory<IBenchmarkQuotes>
) => {
  const url = `${API_BASE}/indexes/quotes`;
  const httpGet = makeHttpGet<IBenchmarkQuotes>();

  return new BenchmarkQuotesUseCase(
    url,
    httpGet,
    getColorRepo,
    getInMemoryRepo
  );
};
